import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRoutes } from './ApiRoutes';
import { Gt2ApiService } from './gt2-api.service';

/**
 * CRUD + catalog + run-now for Configuration → Automatisation
 * (backend container Automation, /v1/automations, MODULE_AUTOMATISATION).
 */
@Injectable({
  providedIn: 'root',
})
export class AutomationService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public getAutomations(): Observable<any> {
    return this.http.get<any>(this.api.createUrl(ApiRoutes.AUTOMATIONS));
  }

  public getCatalog(): Observable<any> {
    return this.http.get<any>(
      this.api.createUrl(ApiRoutes.AUTOMATIONS_CATALOG),
    );
  }

  public createAutomation(automation: any): Observable<any> {
    return this.http.post<any>(
      this.api.createUrl(ApiRoutes.AUTOMATIONS),
      automation,
    );
  }

  public updateAutomation(uuid: string, automation: any): Observable<any> {
    return this.http.patch<any>(
      this.api.createUrl(ApiRoutes.AUTOMATION) + uuid,
      automation,
    );
  }

  public deleteAutomation(uuid: string): Observable<any> {
    return this.http.delete<any>(
      this.api.createUrl(ApiRoutes.AUTOMATION) + uuid,
    );
  }

  public runNow(uuid: string): Observable<any> {
    return this.http.post<any>(
      this.api.createUrl(ApiRoutes.AUTOMATION) + uuid + '/run-now',
      {},
    );
  }

  private stripReadOnlyActionConfig(config: any): any {
    if (!config || typeof config !== 'object') {
      return config;
    }
    const { has_secret, ...rest } = config;
    return rest;
  }

  /**
   * Rebuilds the full PATCH payload from a transformer row — the API expects
   * the complete form shape on update (used by the list's active toggle).
   */
  public payloadFromRow(row: any, overrides: any = {}): any {
    return {
      name: row.name,
      trigger_type: row.trigger_type || 'SCHEDULE',
      trigger_config: row.trigger_config || null,
      task_type: row.task_type,
      task_config: row.task_config,
      rrule: row.rrule,
      run_time: row.run_time,
      date_range_preset: row.date_range_preset,
      date_range_days: row.date_range_days,
      action_type: row.action_type,
      // has_secret is a read-only marker from the transformer — never sent back.
      action_config: this.stripReadOnlyActionConfig(row.action_config),
      availability: row.availability,
      is_active: row.is_active,
      ...overrides,
    };
  }
}
